import { Controller } from "@hotwired/stimulus"
import DataTable from 'datatables.net-bs5'

import 'datatables.net-buttons-bs5'
import 'datatables.net-buttons/js/buttons.html5'
import 'datatables.net-buttons/js/buttons.print'
import 'pdfmake/build/pdfmake'
import 'pdfmake/build/vfs_fonts'
import JSZip from 'jszip'

window.JSZip = JSZip

export default class extends Controller {
  static values = {
    url: String,
    exportUrl: String,
    exportFilePrefix: String,
    dateColumnIndex: Number,
    pageLength: Number
  }

  connect() {
    if (this.element.dataset.datatableInitialized === "true") return
    if ($(this.element).hasClass('dataTable')) return

    const urlParams = new URLSearchParams(window.location.search)
    const ajaxUrl = this.urlValue || window.location.pathname + "/paginate"
    const exportUrl = this.exportUrlValue || window.location.pathname + "/export"
    const filePrefix = this.exportFilePrefixValue || "relatorio"
    const dateColumn = this.dateColumnIndexValue || 3

    this.table = new DataTable(this.element, {
      paging: true,
      serverSide: true,
      processing: true,
      ajax: {
        url: ajaxUrl,
        data: (d) => {
          urlParams.forEach((value, key) => {
            d[key] = value
          })
        }
      },
      dom: '<"html5buttons"B>lTfgitp',
      responsive: true,
      retrieve: true,
      lengthChange: false,
      pageLength: this.pageLengthValue || 20,
      columnDefs: [
        { type: 'date', targets: [dateColumn] }
      ],
      language: { url: "/datatables/pt-BR.json" },
      order: [[0, 'desc']],
      buttons: [
        {
          text: 'CSV',
          className: 'btn btn-outline-primary',
          action: () => {
            window.open(`${exportUrl}.csv?${urlParams.toString()}`, '_blank')
          }
        },
        // { TODO:
        //   text: 'Excel',
        //   className: 'btn btn-outline-success',
        //   action: () => {
        //     window.open(`${exportUrl}.xlsx?${urlParams.toString()}`, '_blank')
        //   }
        // },
        // {
        //   extend: 'pdf',
        //   text: 'PDF',
        //   filename: filePrefix,
        //   exportOptions: {
        //     modifier: { page: 'all' },
        //     columns: ':visible:not(.no-export)'
        //   }
        // },
        // {
        //   extend: 'print',
        //   text: 'Imprimir',
        //   exportOptions: {
        //     modifier: { page: 'all' },
        //     columns: ':visible:not(.no-export)'
        //   },
        //   customize: (win) => {
        //     $(win.document.body).addClass('white-bg')
        //     $(win.document.body).css('font-size', '10px')
        //     $(win.document.body).find('table').addClass('compact').css('font-size', 'inherit')
        //   }
        // }
      ]
    })

    this.element.dataset.datatableInitialized = true
  }
}
